import React, { FC, useEffect, useState } from "react";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { getSettlement } from "../../apis/patientService";
import { errorMessage } from "../../utils/notificationUtils";
import Settlement from "../../components/Settlement/Settlement";
import { errorMessageModal } from "../../utils/modalMessage";

type SettlementContainerProps = {
  activeKey?: any;
}

const SettlementContainer: FC<SettlementContainerProps> = ({
  activeKey
}) => {
  const { patients } = useSelector((state: RootState) => state);
  const [settlementData, setSettlementData] = useState<any>([]);

  const fetchData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        const res = await getSettlement(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        );
        setSettlementData(res);
      } catch (err) {
        errorMessageModal("Please, Try again later");
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey
  ]);

  return <Settlement settlementData={settlementData} fetchData={fetchData} />;
};

export default SettlementContainer;


